// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__Gwhyo","content":"Consent_content__2Rp3U","footer":"Consent_footer__3KlyB"};